<template>
  <form
    @submit="checkDescription"
    class="
      p-4
      sm:p-5
      rounded
      bg-todoBackground-light
      dark:bg-todoBackground-dark
      flex flex-row
      items-center
    "
  >
    <div
      class="
        w-5
        sm:w-6.1
        h-5
        sm:h-6.1
        mr-3
        sm:mr-5
        flex
        items-center
        justify-center
        bg-borderColor-light
        dark:bg-borderColor-dark
        rounded-full
        hover:bg-pattern
      "
    >
      <input
        id="new-task-status"
        type="checkbox"
        v-model="done"
        name="status"
        class="
          w-4
          h-4
          sm:w-6
          sm:h-6
          rounded-full
          border-none
          bg-todoBackground-light bg-no-repeat bg-center
          dark:bg-todoBackground-dark
          font-josefin
          cursor-pointer
          appearance-none
          checked:bg-check
        "
      />
      <label for="new-task-status" class="sr-only">Task Status</label>
    </div>
    <input
      id="new-task-desciption"
      type="text"
      v-model="description"
      name="description"
      maxlength="37"
      class="
        pt-1
        box-border
        text-xs
        sm:text-lg
        font-normal font-josefin
        text-todoText-light
        dark:text-todoText-dark
        bg-transparent
        flex-grow
        outline-none
        placeholder-placeholderText-light
        dark:placeholder-placeholderText-dark
        transition-all
        duration-300
      "
      placeholder="Create a new todo..."
    />
    <label for="new-task-desciption" class="sr-only">Task Desciption</label>
  </form>
</template>
<script>
export default {
  name: "NewTask",
  data() {
    return {
      description: "",
      done: false,
    };
  },
  methods: {
    checkDescription(e) {
      e.preventDefault();

      if (!this.description) {
        alert("Please enter the task description");
        return;
      }

      const newTask = {
        description: this.description,
        done: this.done,
      };

      this.$emit("add-task", newTask);

      // clear input field and reset the checkbox
      this.description = "";
      this.done = false;
    },
  },
};
</script>